import type { GQLResponseOk, ListCollectionSection, ProductsQuery } from '~/types'
import { getPrice } from '~/utils'

type Product = GQLResponseOk<ProductsQuery>['data'][0]

export const sortProducts = (type: ListCollectionSection['settings']['sort']) => (a: Product, b: Product) => {
	switch (type) {
		default:
		case 'featured':
			return a.offer && b.offer ? 0 : a.offer ? -1 : b.offer ? 1 : 0
		case 'alphabetical':
			return a.title.localeCompare(b.title)
		case 'alphabetical_reversed':
			return b.title.localeCompare(a.title)
		case 'products_high':
			return getPrice(b.priceRange.minVariantPrice) - getPrice(a.priceRange.minVariantPrice)
		case 'products_low':
			return getPrice(a.priceRange.minVariantPrice) - getPrice(b.priceRange.minVariantPrice)
		case 'date':
			return new Date(a.publishedAt).getTime() - new Date(b.publishedAt).getTime()
		case 'date_reversed':
			return new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
	}
}
